import ExpertSelection from "../../components/select-experts/select-experts";

const SelectExpertPage = () => <ExpertSelection/>

export default SelectExpertPage;